/* eslint-disable no-mixed-operators */
/* eslint-disable eqeqeq */
import React, { useEffect, useState, useRef } from "react";
import "./producer-slider.css";
import crossIcon from "../../../assets/close.png";
import { useParams } from "react-router-dom";
import { generateClient } from "aws-amplify/api";
import { changeSlide, dragSlideForSequence } from "../../../graphql/mutations";
import {
  onSlideChange,
  onSlideControlToggle,
} from "../../../graphql/subscriptions";
import * as config from "../../../aws-exports";
import { fetchPollResults } from "../../../services/event/pollResults";
import UpdateCurrentSlide from "../../../services/event/update-current-slide";
import CpeCredit from "../../cpe-credit/cpe-credit";
import "../../../components/cpe-credit/cpe-credit.css";
import SlideModal from "../../slide-model/slide-model";
import Back from "../../../assets/angle-left-solid.svg";
import Next from "../../../assets/angle-right-solid.svg";
import { useSlide } from "./SlideProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import dragula from "dragula";
import { setSequence } from "../../../services/event/set-sequence";
import reseticon from "../../../assets/reset.svg";
import updateicon from "../../../assets/update.svg";
import reordericon from "../../../assets/reorder.svg";
import cancelicon from "../../../assets/cancel.svg";

const client = generateClient(config);

interface Slide {
  id: string;
  type:
    | "image"
    | "pollQuestions"
    | "pollresult"
    | "video"
    | "video/mp4"
    | "cpeForm"
    | "HLSStream"
    | "customSlide";
  sequence: number;
  url?: string;
  fileName?: string;
  pollId?: string;
  pollResults?: PollResult[];
  collateralTypeId?: string;
}

interface PollResult {
  option: string;
  percentage: number;
  voteCount: number;
}

interface PollResultData {
  questionTitle: string;
  totalVotes: number;
  results: PollResult[];
}

interface SlidesDisplayProps {
  onSlideSelect: (sequence: number) => void;
  selectedSlideSequence: number;
  slidesData: Slide[];
  pollData: any;
  allPollResultData: PollResultData[];
  role: number;
  viewportHeight: number;
  meetingHeight: number;
  slidesLength: number;
  customSlidesData: any;
  userEmail: string;
  isLoadingUpdateSlides: boolean;
  setIsLoadingUpdateSlides: Function;
  updateSlides: Function;
  selectedSlideId: string;
  setSelectedSlideId: Function;
  meetingStatus: boolean;
  slideControlEnabled: boolean;

}

const SlidesDisplay: React.FC<SlidesDisplayProps> = ({
  onSlideSelect,
  selectedSlideSequence,
  slidesData,
  pollData,
  allPollResultData,
  role,
  viewportHeight,
  meetingHeight,
  slidesLength,
  customSlidesData,
  userEmail,
  isLoadingUpdateSlides,
  setIsLoadingUpdateSlides,
  updateSlides,
  selectedSlideId,
  setSelectedSlideId,
  meetingStatus,
  slideControlEnabled
}) => {
  const { eventId } = useParams<{ eventId: string }>();
  const [slides, setSlides] = useState<Slide[]>(slidesData);
  const [, setCurrentSlide] = useState<Slide | null>(null);
  const [, setIsSubmitted] = useState<boolean>(false);
  const [selectedAnswer, setSelectedAnswer] = useState<Record<string, string>>(
    {}
  );

  const [, setSlideControlEnabled] = useState<boolean>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sequenceChanged, setSequenceChanged] = useState(false);
  const [newSequence, setNewSequence] = useState<any[]>([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const {
    handleNextSlide,
    handlePreviousSlide,
    currentSlideSequence,
    handleSlideChange,
    isSyncing,
  } = useSlide();
  const slidesContainerRef = useRef<HTMLDivElement>(null);

  // Mapping Poll Results
  const pollResultsMap: Record<string, PollResult[]> = {};
  pollData.forEach((poll: any, index: number) => {
    pollResultsMap[poll.pollId] = allPollResultData[index]?.results || [];
  });

  useEffect(() => {
    setSlides(slidesData);
    if (selectedSlideSequence === 0) {
      handleSlideChange(1);
    }
  }, [slidesData, selectedSlideSequence]);

  useEffect(() => {
    const subscription = client.graphql({ query: onSlideChange });
    const observer = subscription.subscribe({
      next: ({ data }) => {
        const type = data.onSlideChange.type;
        if (
          type !== "image" &&
          type !== "pollQuestions" &&
          type !== "pollresult" &&
          type !== "video" &&
          type !== "video/mp4" &&
          type !== "HLSStream" &&
          type !== "cpeForm" &&
          type !== "customSlide"
        ) {
          console.error(`Unexpected slide type: ${type}`);
          return;
        }

        const newSlide: Slide = {
          id: data.onSlideChange.id,
          url: data.onSlideChange.url,
          sequence: data.onSlideChange.sequence,
          type: type,
          pollId: data.onSlideChange.pollId,
          pollResults: data.onSlideChange.pollResults
            ? data.onSlideChange.pollResults.map((result: any) => ({
                option: result.option,
                percentage: result.percentage,
                voteCount: result.voteCount,
              }))
            : undefined,
          collateralTypeId: data.onSlideChange.collateralTypeId? data.onSlideChange.collateralTypeId:data.onSlideChange.id,
        };

        if (newSlide && newSlide.id === eventId) {
          setSelectedSlideId(newSlide.collateralTypeId);
          setCurrentSlide(newSlide);
          setIsSubmitted(false);
          onSlideSelect(newSlide.sequence);
          if (
            newSlide.type === "pollresult" &&
            newSlide.pollResults &&
            newSlide.pollId
          ) {
            setCurrentSlide({
              ...newSlide,
              pollResults: pollResultsMap[newSlide.pollId!],
            });
          }
        }
      },
      error: (error) => console.warn("Subscription error:", error),
    });

    return () => observer.unsubscribe();
  }, [onSlideSelect]);

  useEffect(() => {
    const subscription = client.graphql({ query: onSlideControlToggle });
    const observer = subscription.subscribe({
      next: ({ data }) => {
        const controlData = data.onSlideControlToggle;
        if (controlData.eventid === eventId && controlData.email == userEmail) {
          setSlideControlEnabled(controlData.enableSlideControl);
        }
      },
      error: (error) => console.warn("Subscription error:", error),
    });

    return () => observer.unsubscribe();
  }, [eventId]);

  useEffect(() => {
    const cookieName = `${eventId}-${userEmail}`;
    const savedSlideControlStatus = Cookies.get(cookieName);
    if (savedSlideControlStatus !== undefined) {
      setSlideControlEnabled(savedSlideControlStatus === "true");
    }
  }, [eventId]);

  useEffect(() => {
    if (!slidesContainerRef.current || !slideControlEnabled || !isEditMode || meetingStatus
      ){
      if(sequenceChanged) {
        handleRevertSequence();
      }
      return;
    }

    const drake = dragula([slidesContainerRef.current], {
      moves: (el, container, handle, sibling): boolean => {
        // Ensure we have an element to check
        if (!el) return false;

        // Check if element or its parent has poll-result class
        if (
          el.classList.contains("poll-result") ||
          el.closest(".poll-result")
        ) {
          return false;
        }

        // Find the slide element
        const slideElement = el.classList.contains("slide")
          ? el
          : el.closest(".slide");
        if (!slideElement) return false;

        const slideId = slideElement.getAttribute("data-id");
        if (!slideId) {
          console.log("No slide ID found");
          return false;
        }

        const slide = slides.find((s) => s.id === slideId);
        console.log("Found slide for dragging:", slide);

        // Always return a boolean
        return slide?.type !== "pollresult" && slide?.type !== "cpeForm";
      },
      direction: "horizontal",
      removeOnSpill: false,
      copy: false,
      accepts: (el, target, source, sibling) => {
        return true;
      },
      revertOnSpill: true,  // revert to original position if dropped outside
    });

    drake.on("drop", async (el, target) => {
      if (!target) return;

      const items = Array.from(target.children);
      const newSlides = [...slides];
      let extra = 0;

      // Update DOM order immediately
      items.forEach((item, index) => {
        const slideId = item.getAttribute("data-id");
        const slideIndex = newSlides.findIndex((s) => s.id === slideId);
        if (slideIndex !== -1) {
          newSlides[slideIndex] = {
            ...newSlides[slideIndex],
            sequence: index + 1 - extra,
          };
        } else {
          extra++;
        }
      });

      setSlides(newSlides);

      const slidesToSend = newSlides
        .filter(
          (slide) =>
            !slide.id.endsWith("-result") && slide.id != "dynamic_cfb_slide"
        )
        .map((slide) => ({
          id: slide.id,
          sequence: slide.sequence,
        }));

      const sortedSlides = slidesToSend.sort((a, b) => a.sequence - b.sequence);
      setNewSequence(sortedSlides);
      setSequenceChanged(true);
    });

    return () => {
      drake.destroy();
    };
  }, [role, slideControlEnabled, slides, isEditMode, meetingStatus]);

  const handleUpdateSequence = async () => {
    setIsLoadingUpdateSlides(true);
    try {
      const slide = slides.find(item =>(item.collateralTypeId?item.collateralTypeId:item.id) === selectedSlideId);
      await UpdateCurrentSlide({ slide: slide }, eventId);
      await setSequence({ items: newSequence }, parseInt(eventId || "0"));
      await slideDraging();
      setSequenceChanged(false);
      handleEdit();
    } catch (error) {
      console.error("Error updating sequence:", error);
    }
  };

  const handleRevertSequence = async () => {
    setSequenceChanged(false);
    await updateSlides();
    handleEdit();
  };

  const slideDraging = async () => {
    try {
      const newStatus = true;
      await client.graphql({
        query: dragSlideForSequence,
        variables: { eventid: eventId!, isDragging: newStatus },
      });
    } catch (error) {
      console.error("Error toggling slide control:", error);
    }
  };

  const renderPollResults = (pollId: string) => {
    const results = pollResultsMap[pollId];

    if (!results || results.length === 0) {
      return <div>Loading poll results...</div>;
    }

    return (
      <div
        className="poll-result silder-poll-wrapper"
        style={{ height: "80px", overflowY: "scroll" }}
      >
        {results.map((result) => (
          <div
            key={result.option}
            className="poll-result-item poll-silder-view"
          >
            <div className="poll-option">{result.option}</div>
            <div className="poll-percentage">
              <div
                className="poll-bar"
                style={{
                  width: `${result.percentage}%`,
                  backgroundColor: "#007bff",
                }}
              ></div>
              <div className="poll-text">
                {result.percentage}% ({result.voteCount} votes)
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderSlides = () => {
    return slides.map((slide: Slide) => {
      const poll = pollData.find((poll: any) => poll.pollId === slide.pollId);
      const pollType = poll?.pollType || "radio"; // Default to 'radio' if pollType is not defined
      const customSlide = customSlidesData.find(
        (customSlide: any) =>
          customSlide.collateralTypeId === slide.collateralTypeId
      );
      const liveSlide = slide.collateralTypeId
        ? slide.collateralTypeId
        : slide.id;

      const slideComponents = [];

      if (slide.type !== "pollresult") {
        slideComponents.push(
          <div
            key={slide.id}
            className={`slide ${
              selectedSlideId === liveSlide ? "selected" : ""
            }`}
            onClick={(e) => {
              if (!e.defaultPrevented) {
                handleSlideChange(slide.sequence);
              }
            }}
            data-id={slide.id}
            data-sequence={slide.sequence}
            style={{cursor: role === 0 && !slideControlEnabled  ? "not-allowed" : "pointer",
            }}
          >
            {slide.type === "image" && (
              <div className="img-video-wrapper">
                <img
                  crossOrigin="anonymous"
                  src={slide.url}
                  alt={`Slide ${slide.sequence}`}
                />
              </div>
            )}
            {(slide.type === "video" ||
              slide.type === "video/mp4" ||
              slide.type === "HLSStream") && (
              <div className="img-video-wrapper">
                <video
                  src={slide.url}
                  muted
                  style={{ width: "100%", height: "120px" }}
                />
              </div>
            )}
            {slide.type === "pollQuestions" && poll && (
              <div className="poll-question">
                <h3 className="silder-poll-question-wrapper">
                  Q.{poll.questionTitle}
                </h3>
                <form>
                  {Object.entries(poll.options).map(([key, value]) => (
                    <div key={key}>
                      <input
                        type={pollType === "checkbox" ? "checkbox" : "radio"} // Dynamic input type based on pollType
                        id={key}
                        name={`question-${poll.pollId}`}
                        value={key}
                        checked={selectedAnswer[poll.pollId] === key}
                        onChange={() =>
                          setSelectedAnswer({
                            ...selectedAnswer,
                            [poll.pollId]: key,
                          })
                        }
                        disabled={role === 0 && !slideControlEnabled}
                      />
                      <label className="silder-option-wrapper" htmlFor={key}>
                        {String(value)}
                      </label>
                    </div>
                  ))}
                </form>
              </div>
            )}
            {slide.type === "customSlide" && customSlide && (
              <div className="custom-slide-wrapper-control">
                <div>{customSlide.title}</div>
                <div>{customSlide.description}</div>
                {customSlide.hyperlinks &&
                  customSlide.hyperlinks.length > 0 && (
                    <div className="custom-slide-links-control">
                      {customSlide.hyperlinks.map(
                        (
                          link: { title: string; url: string },
                          index: number
                        ) => (
                          <div key={index} className="custom-slide-link">
                            <a
                              href={link.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {link.title}
                            </a>
                          </div>
                        )
                      )}
                    </div>
                  )}
              </div>
            )}
            {slide.type === "cpeForm" && (
              <CpeCredit className="file1-classname" />
            )}
            {selectedSlideId === liveSlide && (
              <div className="live-icon">Live</div>
            )}
          </div>
        );

        if (slide.type === "pollQuestions" && poll) {
          const pollResultSlide: Slide = {
            id: `${slide.id}-result`,
            type: "pollresult",
            sequence: slide.sequence + 0.1,
            pollId: slide.pollId,
            url: "",
          };

          if (!slides.some((s) => s.sequence === pollResultSlide.sequence)) {
            slides.push(pollResultSlide);
          }

          slideComponents.push(
            <div
              key={pollResultSlide.id}
              className={`slide ${
                currentSlideSequence === pollResultSlide.sequence
                  ? "selected"
                  : ""
              }`}
              onClick={() => handleSlideChange(pollResultSlide.sequence)}
              style={{
                cursor:
                  role === 0 && !slideControlEnabled
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              {renderPollResults(slide.pollId!)}
              {currentSlideSequence === pollResultSlide.sequence && (
                <div className="live-icon">Live</div>
              )}
            </div>
          );
        }
      }

      return slideComponents;
    });
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Check if user is typing in an input field (chat, Q&A, or any other input)
      const activeElement = document.activeElement as HTMLElement;

      const isTypingInInput = activeElement && (
        activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.contentEditable === 'true' ||
        activeElement.getAttribute('role') === 'textbox'
      );

      if (
      role === 0 && !slideControlEnabled ||
        isSyncing ||
        sequenceChanged ||
        isTypingInInput
      ) {
        return;
      }
      if (e.key === "ArrowLeft") {
        handlePreviousSlide();
      } else if (e.key === "PageUp") {
        e.preventDefault();
        handlePreviousSlide();
      } else if ((e.key === "ArrowRight") && currentSlideSequence < maxSequence) {
        handleNextSlide();
      } else if (e.key === "PageDown") {
        e.preventDefault();
        handleNextSlide();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [role, slideControlEnabled, isSyncing, sequenceChanged]);

  const maxSequence = Math.max(...slides.map((slide) => slide.sequence));

  // Modal handlers
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleEdit = () => {
    setIsEditMode(!isEditMode);
  };

  return (
    <div className="main-slider-wrapper">
      <div style={{ borderRadius: "10px" }}>
        <div className="slider-header-wrapper">
          <div className="inner-left-wrapeer">
            <p className="slide-control-text">Slide control</p>
            <button className="view-slide-button" onClick={handleOpenModal}>
              Preview Slides
            </button>
          </div>
          <div className="slide-controls">
            {isSyncing && (
              <FontAwesomeIcon className="fa-spinner" icon={faSpinner} spin />
            )}
            <button
              className="arrow-button"
              onClick={handlePreviousSlide}
              disabled={
                currentSlideSequence === 1 ||
                (role === 0 && !slideControlEnabled) ||
                isSyncing ||
                sequenceChanged
              }
              style={{
                cursor:
                  role === 0 && !slideControlEnabled
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              <img className="left-arrow" src={Back} alt="back-arrow" />
            </button>
            <button
              className="arrow-button"
              onClick={handleNextSlide}
              disabled={
                currentSlideSequence >= maxSequence ||
                (role === 0 && !slideControlEnabled) ||
                isSyncing ||
                sequenceChanged
              }
              style={{
                cursor:
                  role === 0 && !slideControlEnabled
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              <img className="right-arrow" src={Next} alt="next-arrow" />
            </button>
          </div>
        </div>
        {isModalOpen && (
          <SlideModal slides={slides} handleCloseModal={handleCloseModal} />
        )}
        <div>
          <img
            src={crossIcon}
            alt="Close icon"
            style={{
              marginRight: "20px",
              width: "13px",
              height: "13px",
              cursor: "pointer",
              display: "none",
            }}
          />
        </div>
        <hr style={{ marginTop: "0", marginBottom: "0" }} />
      </div>
      <div style={{ position: "relative", flex: 1, minHeight: 0 }}>
        {isLoadingUpdateSlides ? (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 2,
            }}
          >
            <FontAwesomeIcon className="fa-spinner" icon={faSpinner} spin />
          </div>
        ) : (
          <div
            className="slides-container"
            ref={slidesContainerRef}
            style={{
              opacity: isLoadingUpdateSlides ? 0.5 : 1,
              transition: "opacity 0.3s ease",
              cursor: isEditMode ? "grab" : "default",
            }}
          >
            {renderSlides()}
          </div>
        )}
      </div>
      <hr style={{ marginTop: "0", marginBottom: "0" }} />
      {!meetingStatus &&  
        <div className="sequence-buttons-container">
        {
          !sequenceChanged &&
          <button
            className="view-slide-button"
            onClick={handleEdit}
            style={{
              backgroundColor: isEditMode ? "#ff4444" : undefined,
              color: isEditMode ? "white" : undefined,
              opacity: sequenceChanged && isEditMode ? 0.5 : 1,
          cursor: sequenceChanged && isEditMode ? "not-allowed" : "pointer",
            }}
            disabled={sequenceChanged && isEditMode}
            title={isEditMode ? "Cancel" : "Reorder"}
          >
            <img src={isEditMode ? cancelicon : reordericon} />
          </button>
        }
        {
          sequenceChanged &&
          <button
            className="sequence-button revert"
            onClick={handleRevertSequence}
            disabled={!sequenceChanged}
            title="Reset"
          >
            <img src={reseticon} />
          </button>
        }
        {
          sequenceChanged &&
          <button
            className="sequence-button save"
            onClick={handleUpdateSequence}
            disabled={!sequenceChanged}
            title="Update"
          >
            <img src={updateicon} />
          </button>
        }
        </div>
      } 
    </div>
  );
};

export default SlidesDisplay;
